import { EmptySelect } from "./EmptySelect";
import { SelectedCard } from "./SelectedCard";
import { useAccountProducts } from "./useAccountProducts";
import type { ProductPickerProps } from "./types";

export type { ProductPickerProps, ProductPickerValue } from "./types";

export const ProductPicker = ({ linkId, value, onChange, disabled }: ProductPickerProps) => {
  const list = useAccountProducts(linkId);
  if (value.productId) {
    return <SelectedCard value={value} list={list} disabled={disabled} onChange={onChange} />;
  }
  return <EmptySelect list={list} disabled={disabled} onChange={onChange} />;
};
